import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Paginable, PaginableParams } from '../../utils/pagination.utils';
import { RealEstateLocationsServiceApi } from './real-estate-locations.service.api';
import { RealEstateLocationsServiceMock } from './real-estate-locations.service.mock';

export type RealEstateLocationStatePaginableParams = PaginableParams;

export interface RealEstateLocationMunicipalityPaginableParams extends PaginableParams {
  state: string;
}

export interface RealEstateLocationNeighborhoodPaginableParams extends PaginableParams {
  municipality: string;
  state: string;
}

export interface RealEstateLocationSearchParams {
  limit: number;
  term: string;
}

export interface RealEstateLocationSuggestion {
  label: string;
  municipality?: string;
  postalCode?: string;
  settlement?: string;
  state: string;
}

@Injectable({
  providedIn: 'root',
  useClass: environment.usingMocks ? RealEstateLocationsServiceMock : RealEstateLocationsServiceApi,
})
export abstract class RealEstateLocationsService {
  abstract getAllMunicipalities(params: RealEstateLocationMunicipalityPaginableParams): Promise<Paginable<string>>;
  abstract getAllNeighborhoods(params: RealEstateLocationNeighborhoodPaginableParams): Promise<Paginable<string>>;
  abstract getAllStates(params: RealEstateLocationStatePaginableParams): Promise<Paginable<string>>;
  abstract search(params: RealEstateLocationSearchParams): Promise<RealEstateLocationSuggestion[]>;
}
